<template>
  <div id="vhss_aiPlayer"></div>
</template>

<script>
import { onMounted } from 'vue';

export default {
  name: 'AiPlayer',
  setup() {
    onMounted(() => {
      // Load the external script dynamically
      const script1 = document.createElement('script');
      script1.type = 'text/javascript';
      script1.src = '//vhss.oddcast.com/ai_embed_functions_v1.php';
      document.body.appendChild(script1);

      // Load the AI embed function after the script is loaded
      script1.onload = () => {
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.innerHTML = 'AI_vhost_embed(800,600,3432155,198,1,1);';
        document.body.appendChild(script2); 
      };
    });
  }
};
</script>